import React from 'react'

import * as MdIcons from 'react-icons/md'
import { useParams, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { FieldLabel } from '@components/Form/FieldLabel'
import { Separator } from '@components/Separator'
import { useFindSiteResources } from '@hooks/catalogs/resources'

import {
  DummyAssignmentDescription,
  DummyAssignmentTouchable,
  DummyAssignmentsContainer,
  DummyAssignmentInformationContainer,
} from './styles'
import { useAddTaskContext } from '../../AddTaskContext'

export function ListDummyAssignments() {
  const theme = useTheme()

  const { data: rawResources } = useFindSiteResources()

  const { assignmentsData } = useAddTaskContext()

  const navigate = useNavigate()

  function handleNavigateEditAssignment(dummyAssignmentId: string) {
    navigate(
      `edit-dummy-assignment/${dummyAssignmentId}/${getDummyAssignmentDuration(dummyAssignmentId)}`,
    )
  }

  function getDummyAssignmentDuration(dummyAssignmentId: string) {
    return assignmentsData.find(
      (a) => a.dummyAssignmentId === dummyAssignmentId,
    )?.duration
  }

  const findResource = (resourceId: number) =>
    rawResources?.find((resource) => resource.id === resourceId)

  return (
    <>
      {assignmentsData.length > 0 && <FieldLabel>Resources</FieldLabel>}

      <DummyAssignmentsContainer>
        {assignmentsData.length > 0 &&
          assignmentsData.map((assignment) => {
            const resource = findResource(assignment.resourceId)
            return (
              <>
                <DummyAssignmentTouchable
                  onClick={() =>
                    handleNavigateEditAssignment(assignment.dummyAssignmentId)
                  }
                >
                  <div>
                    <DummyAssignmentInformationContainer>
                      <DummyAssignmentDescription>
                        {resource?.description}
                      </DummyAssignmentDescription>
                      <MdIcons.MdArrowForwardIos
                        size={24}
                        color={theme.colors.text}
                      />
                    </DummyAssignmentInformationContainer>
                  </div>
                </DummyAssignmentTouchable>
                <Separator />
              </>
            )
          })}
      </DummyAssignmentsContainer>
    </>
  )
}
